import { CSSObject } from '@chakra-ui/react';

export const betCardErrorFlexProps: CSSObject = {
  borderTopRadius: 'sm',
};

export const BetPropositionClosedError: CSSObject = {
  bg: 'rgba(63, 27, 66, 0.7)',
  borderRadius: 'md',
  position: 'absolute',
  top: '-2px',
  left: '-2px',
  w: 'calc(100% + 4px)',
  h: 'calc(100% + 4px)',
  pb: '0',
  alignItems: 'center',
  justifyContent: 'center',
  overflow: 'hidden',
  zIndex: 'docked',
};

export const BetCardContainer = (): CSSObject => ({
  borderColor: 'rgba(255, 255, 255, 0.16)',
  border: '1px solid',
  bg: 'linear-gradient(116deg, rgba(255, 255, 255, 0.12) 1.57%, rgba(255, 255, 255, 0.05) 100%)',
  borderRadius: '8px',
  color: 'white',
  boxShadow: '0px 2px 5px 0px rgba(0, 0, 0, 0.25)',
});

export const IconButtonThemed: CSSObject = {
  w: 'unset',
  minW: 'unset',
  justifyContent: 'right',
  color: 'white',
  mr: '-1',
};

export const ExoticsNumberContainer: CSSObject = {
  w: '6 ',
};

export const InfoBetOdds: CSSObject = {
  color: 'white',
  display: 'flex',
  fontWeight: 'extrabold',
  fontSize: 'sm',
};

export const BetOdds: CSSObject = {
  display: 'none',
};

export const EventTitle: CSSObject = {
  fontWeight: 'bold',
  fontSize: 'sm',
  flex: '1',
  textTransform: 'capitalize',
  fontFamily: 'accent',
  textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
};

export const EventMarketName = (isExtraInfo: boolean) => ({
  display: !isExtraInfo && 'none',
  fontSize: 'xs',
  color: 'beta.300',
  fontWeight: 'bold',
  textTransform: 'capitalize',
  textShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
  fontFamily: 'accent',
});

export const EventSubtitle: CSSObject = {
  fontWeight: 'medium',
  color: 'white',
  textTransform: 'capitalize',
  fontSize: 'xs',
  fontFamily: 'accent',
};

export const ExoticsPlaceContainer: CSSObject = {
  fontWeight: 'bold',
  fontSize: 'xs',
};

export const TextExoticSelections: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'medium',
};

export const FlexPlacedContainer: CSSObject = {
  p: '2',
};

export const BetPlaced: CSSObject = {
  bg: 'linear-gradient(180deg, white 0%, var(--bc-colors-gray-300) 100%)',
  boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.2), inset 0px 1px 0px #FFFFFF',
  borderRadius: 'base',
  flexDirection: 'column',
  color: 'alpha.700',
};

export const TextExoticsLabel: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'bold',
};

export const TextExoticsInfo: CSSObject = {
  fontSize: 'xs',
  fontWeight: 'normal',
};

export const StakeButton: CSSObject = {
  h: '9',
  bgGradient:
    'linear-gradient(180deg, var(--bc-colors-theta-50) 0%, var(--bc-colors-theta-100) 100%)',
  color: 'yellow.900',
  borderRadius: 'sm',
  boxShadow: '0px 4px 5px rgba(241, 186, 69, 0.2)',
  textShadow: 'none',

  _hover: {
    bgGradient:
      'linear-gradient(180deg, var(--bc-colors-gamma-200) 0%, var(--bc-colors-gamma-300) 100%)',
  },
};

export const BetPropositionClosedButton: CSSObject = {
  bg: 'alpha.900',
  color: 'white',
  borderRadius: 'base',
  fontSize: 'xs',
  px: '3.5',
  h: '8',
  _hover: {
    bg: 'alpha.800',
  },
};

export const BonusBetsButton = (isBonusBet: boolean) => ({
  bg: isBonusBet ? 'alpha.800' : 'alpha.400',
  boxShadow:
    '0px 2px 3px rgba(0, 0, 0, 0.15), inset 0px 1px 0px rgba(255, 255, 255, 0.45)',
  color: isBonusBet ? 'white' : 'alpha.900',
  borderRadius: 'base',
  fontSize: '2xs',
  h: '6',
  px: '1.5',
  '&&': {
    minW: '20',
  },

  _hover: {
    bg: isBonusBet ? 'alpha.900' : 'alpha.500',
  },
});

export const StakeCollapse: CSSObject = {
  '&&': {
    m: '0',
    mt: '2',
  },
};

export const ExoticsFooterContainer: CSSObject = {
  pt: '0',
};

export const BetCardSVG = (header: boolean) => ({
  color: header ? 'beta.300' : 'beta.500',
  boxSize: '6',
  display: header ? 'block' : 'none',
  mr: '0',
});

export const FlexBonusBetsWrapper = (displayBonusBetsButton: boolean) => ({
  mt: displayBonusBetsButton && '0',
  py: '0',
  flexDir: 'column-reverse',
  gap: '1.5',
});

export const BetCardVStack: CSSObject = {
  pb: '2',
};
